import h from "../services/h";

const messageMapping = {
  "documentAssistanceLeader.exists" : "Cấu hình cho lãnh đạo đã tồn tại.",
  "incomingDoc.create.duplicateBookNumber": "Số sổ đã tồn tại",
  "incomingDoc.update.statusMissMatch": "Trạng thái văn bản không hợp lệ",
  "incomingDoc.update.userDeptIdMissMatch":
    "User không có quyền tiếp nhận văn bản",
  "vbOutgoingDoc.update.roleMissMath": "Bạn không có quyền văn thư",
  "vbOutgoingDoc.update.deptMissMath":
    "Bạn phải là văn thư của đơn vị ban hành",
  "incomingDoc.update.outGoingDocMissMath":
    "Văn bản phải là văn bản được upload bên ngoài",
  "incomingDoc.update.bookDeptIdMissMatch": "Sổ văn bản không hợp lệ",

  "vbOutgoingDoc.update.statusMissMatch": "Trạng thái văn bản không hợp lệ",
  "vbOutgoingDoc.update.userDeptIdMissMatch":
    "User không có quyền tiếp nhận văn bản",

  "outgoingDoc.hieuChinh.publisherIdMissMatch": "Đơn vị phát hành không hợp lệ",
  "vbOutgoingDoc.hieuChinh.statusNotMatch": "Trạng thái văn bản không hợp lệ",
  "vbOutgoingDoc.defaultSignContent": "Đồng ý",
  "vbOutgoingDoc.defaultSignContent2": "Kính trình",
  "vbOutgoingDoc.permanentDelete.confirm":
    "Bạn có muốn xóa vĩnh viễn văn bản này?",
  "vbOutgoingDoc.permanentDeleteMultiple.confirm":
    "Bạn có muốn xóa vĩnh viễn những văn bản được chọn ?",
  "vbOutgoingDoc.permanentDelete.success": "Xóa văn bản thành công",
  "vbOutgoingDoc.permanentDelete.failed": "Xóa văn bản thất bại",
  "vbOutgoingDoc.restore.confirm": "Bạn có muốn khôi phục văn bản này?",
  "vbOutgoingDoc.restore.success": "Khôi phục văn bản thành công",
  "vbOutgoingDoc.permanentDelete.invalidStatus":
    "Trạng thái văn bản không hợp lệ",
  "vbOutgoingDoc.permanentDelete.creatorMissMatch":
    "Chỉ người soạn thảo văn bản mới có quyền thực hiện thao tác",

  "vbBook.create.duplicateBookName": "Tên sổ văn bản đã tồn tại",
  "vbBook.update.deptIdMissMatch": "Bạn không có quyền cập nhật thông tin sổ",
  "vbBook.update.duplicateBookName": "Tên sổ văn bản đã tồn tại",
  "vbBook.delete.existsDocInBook":
    "Không thể xóa sổ do đã có văn bản tồn tại trong sổ",
  "vbBook.create.warning":
    "Đến thời điểm 01/12/2019, hệ thống e-Office sẽ thực hiện triển khai chính thức. Vì vậy văn thư cần đồng bộ thông tin sổ từ hệ thống TĐHVP!",

  "vbIncomingProcess.chuyenXuLi.docStatusMissMatch":
    "Trạng thái văn bản không hợp lệ",
  "vbOutgoingProcess.chuyenXuLi.docStatusMissMatch":
    "Trạng thái văn bản không hợp lệ",

  "tkTaskAssign.delete.taskStatusMissMath": "Trạng thái công việc không hợp lệ",
  "tkTaskAssign.create.taskStatusMissMath": "Trạng thái công việc không hợp lệ",

  "tkTask.create.receiverMissMatch":
    "Người thực hiện phải nằm trong nhóm phối hợp",
  "tkTask.create.parentTaskStatusMissMatch":
    "Trạng thái công việc cha không hợp lệ",
  "tkTaskDocRelation.create.taskStatusMissMatch":
    "Trạng thái công việc không hợp lệ",
  "tkTaskDocRelation.delete.taskStatusMissMatch":
    "Trạng thái công việc không hợp lệ",
  "tkTask.changeReceiver.receiverNotChanged":
    "Cần thực hiện thay đổi thông tin người thực hiện!",
  "tkTask.changeReceiver.assignerNotMatch":
    "Bạn không có quyền thay đổi thông tin người thực hiện",
  "tkTask.changeReceiver.taskStatusNotMatch":
    "Chỉ công việc chờ phê duyệt & chưa hoàn thành mới được thay đổi thông tin người thực hiện",
  "tkTask.changeReceiver.receiverNotMatch":
    "Bạn không có quyền giao việc cho người thực hiện mới",
  "tkTask.changeReceiver.success": "Cập nhật công việc thành công",
  "tkTask.canNotViewTask":
    "Bạn không có quyền xem thông tin công việc do thông tin đăng nhập không hợp lệ",
  "tkTask.notFound": "Công việc đã bị hủy hoặc không tồn tại",
  "tkTask.deleteSuccess": "Xóa công việc thành công",
  "tkTask.invalidForm": "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
  "tkTask.delete.onlyAssignerOrDelegatorCanDelete":
    "Bạn không có quyền xóa công việc",
  "tkTask.comment.contentRequired": "Nội dung bình luận chưa được nhập",
  "tkTask.taskAssign.removeConfirmMsg":
    "Bạn có muốn bỏ {0} khỏi danh sách người phối hợp",
  "tkTask.taskAssign.removeSuccess": "Xóa người phối hợp thành công",
  "tkTaskAssign.delete.assignerOrReceiverNotMatch":
    "Bạn không có quyền sửa thông tin người phối hợp",
  "tkTaskAssign.add.assignerOrReceiverNotMatch":
    "Bạn không có quyền sửa thông tin người phối hợp",
  "tkTask.cancel.confirm": "Bạn có chắc chắn muốn hủy công việc?",
  "tkTask.continue.confirm": "Bạn có muốn tiếp tục công việc không?",
  "tkTask.cancelRegister.confirm": "Bạn có muốn hủy phê duyệt công việc không?",
  "tkTask.cancel.success": "Hủy công việc thành công",
  "tkTask.continue.success": "Tiếp tục công việc thành công",
  "tkTask.cancelRegister.success": "Hủy đăng ký công việc thành công",
  "tkTask.update.invalidDateRange":
    "Hạn hoàn thành không được nhỏ hơn ngày bắt đầu",

  "vbIncomingDoc.ketThuc.docStatusMissMatch": "Trạng thái văn bản không hợp lệ",
  "vbIncomingDoc.ketThuc.flowInstanceStatusMissMatch":
    "Trạng thái luồng không hợp lệ",
  "vbIncomingDoc.ketThuc.processStatusMissMatch":
    "Trạng thái luồng không hợp lệ",
  "vbIncomingDoc.ketThuc.receiverMissMatch": "Bạn không có quyền kết thúc",
  "incomingDoc.create.flowMissMatch":
    "Luồng phải là quy trình đến theo đơn vị của user đăng nhập",

  "users.update.duplicatedUserName": "Tên đăng nhập đã tồn tại",
  "users.create.duplicatedUserName": "Tên đăng nhập đã tồn tại",
  "users.create.duplicatedEmail": "Email đã tồn tại",
  "users.update.duplicatedEmail": "Email đã tồn tại",
  "users.create.overMaxNumberUsers":"Số lượng user vượt quá giới hạn gói dịch vụ",

  "users.networkCode.vinaphoneCa": "VinaPhoneCA",
  "users.networkCode.ViettelCA": "ViettelCA",
  "users.networkCode.mobiCa": "MobiCA",
  "users.networkCode.token_mobiCa": "Token MobiCA",
  "users.networkCode.banCycp": "CA Ban cơ yếu chính phủ",
  "users.mobileSignerNetwork.required": "Loại ký số bắt buộc nhập",
  "users.create.invalidForm": "Có lỗi nhập liệu",
  "users.update.invalidForm": "Có lỗi nhập liệu",

  "vbOutgoingDoc.thuHoi.canNotThuHoi":
    "Văn bản sẽ không được thu hồi nếu đã được chuyển xử lý cho người khác",
  "vbOutgoingDoc.thuHoi.statusNotMatch":
    " Văn bản không thể thu hồi nếu đang trong trạng thái đang xử lý",
  "vbOutgoingDoc.thuHoi.ownerNotMatch":
    "Văn bản này chỉ được thu hồi bời người soạn thảo",
  "vbOutgoingDocProcess.thuHoi.ownerNotMatch":
    "Chỉ người chuyển xử lý mới có thể thu hồi",
  "vbOutgoingDocProcess.thuHoi.statusNotMatch":
    "Step phải ở trạng thái đã xử lý",
  "vbOutgoingDocProcess.thuHoi.canNotThuHoi":
    "Văn bản sẽ không được thu hồi nếu đã được chuyển tiếp cho người khác hoặc đã được ban hành",
  "vbOutgoingDoc.update.statusNotMatch":
    "Không thể chuyển xử lý khi trạng thái văn bản không phải tạo mới hoặc từ chối",
  "vbOutgoingDoc.delete.statusMissMatch": "Trạng thái văn bản không hợp lệ",
  "vbOutgoingDoc.delete.creatorMissMatch":
    "Không thể xóa văn bản do người khác tạo",

  "vbBook.delete.error": "Không thể xóa khi sổ đã có văn bản",

  "bookDoc.create.invalidForm": "Kiểm tra lại form nhập liệu",
  "bookDoc.update.invalidForm": "Kiểm tra lại form nhập liệu",
  "bookDoc.create.error":
    "Không thể book số. Ngày book sổ phải lớn hơn hoặc bằng ngày hiện tại",
  "bookDoc.update.error": "Không thể cập nhật book số",
  "bookDoc.delete.error": "Không thể xóa khi trạng thái đã giữ số",
  "vbIncomingProcess.thuHoi.nextVbIncomingProcessStatusMissMatch":
    "Không thể thu hồi do {0} đã chuyển xử lý văn bản này",

  unknownError: "Lỗi không xác định",
  "error.default.403": "Bạn không có quyền truy cập dữ liệu",
  "error.default.401": "Thông tin đăng nhập không đúng. Mời liên hệ quản trị",
  "incomingDoc.canNotAccess": "Bạn không có quyền truy cập thông tin văn bản",
  "outgoingDoc.canNotAccess": "Bạn không có quyền truy cập thông tin văn bản",
  "file.invalidFileType": "Định dạng file không hợp lệ",
  "file.onlyAllowPdfType": "Chỉ được tải file có định dạng pdf",
  "file.onlyAllowDocOutType": "Chỉ được tải file có định dạng pdf hoặc docx",
  "file.onlyAllowPdf": "Chỉ được tải file có định dạng pdf",
  "file.onlyAllowPngType": "Chỉ được tải file có định dạng png",
  "file.invalidFileSize": "Dung lượng file không được vượt quá {0}MB",
  "file.uploadFail": "Tải file thất bại",

  "department.create.deptCodeExists": "Mã phòng ban đã tồn tại.",
  "department.create.identityCodeDuplicated": "Mã định danh đơn vị đã tồn tại.",
  "department.update.identityCodeDuplicated": "Mã định danh đơn vị đã tồn tại.",
  "department.update.deptNameDuplicated": "Tên đơn vị đã tồn tại.",
  "department.invalidAdminRight":
    "Bạn không có quyền cập thông tin đơn vị được chọn.",
  "department.caProvider.mobiCa": "Token MobiCa",
  "department.caProvider.banCycp": "Token Ban Cơ yếu chính phủ",
  "department.create.success": "Tạo mới đơn vị thành công",
  "department.update.success": "Cập nhật đơn vị thành công",

  "signCA.error": "Ký số thất bại, vui lòng ký lại",
  "signCA.mobileRequired": "Chưa có số điện thoại ký số",
  "signHSM.authentFail": "Lấy thông tin chứng thư số thất bại",
  "signHSM.getCertError": "Lấy thông tin chứng thư số thất bại ",
  "signHSM.uuidWrong": "Thông tin UUID do admin khai báo không đúng",
  "signHSM.pass2Wrong": "Mật khẩu cấp 2 không đúng",

  LOCKED_DOCUMENT: "Văn bản đang được xử lý. Xin vui lòng đợi",
  "signRM.timeout": "Hết thời gian ký số, vui lòng nhấn ký lại trên hệ thống eOffice",

  "token.expired": "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
  "user.notFound": "User không tồn tại trong hệ thống. Mời liên hệ quản trị.",
  "user.notAuthorized": "User không có quyền truy cập. Mời liên hệ quản trị.",
  userDeptRoleNotFound: "User chưa được phân quyền. Mời liên hệ quản trị.",

  "bookDoc.bookDocDateMustBeInFuture":
    "Ngày book số không được nhỏ hơn ngày hiện tại",
  "bookDoc.userCanNotAccessBook": "Bạn không có quyền thao tác trên sổ",
  "bookDoc.invalidCurrentNumber":
    "Số hiện tại không được nằm ngoài dải số đã book",
  "bookDoc.currentNumberRequired": "Số hiện tại bắt buộc nhập",
  "bookDoc.userCanNotAccessBookDoc": "Bạn không có quyền chỉnh sửa bản ghi này",
  "bookDoc.canNotDeleteActiveBookDoc": "Bạn không thể xóa yêu cầu đã giữ số",

  "tokenCA.error":
    "Ký số Token-CA bị lỗi. Hãy đảm bảo rằng bạn đã cài đặt phần mềm CyberSign-Client & cắm USB-Token.",
  "tokenCA.signPdfError": "Ký số Token-CA bị lỗi. Chi tiết: {0}",
  "outgoingDoc.banHanh.signedBase64Required":
    "Văn bản cần ký Token-CA trước khi ban hành.",

  "userDeptRole.invalidAdminRight":
    "Bạn không có quyền cập nhật quyền đang chọn!",
  "userDeptRole.update.userDeptRoleDuplicated":
    "Thông tin phân quyền đã tồn tại!",
  "userDeptRole.create.userDeptRoleDuplicated":
    "Thông tin phân quyền đã tồn tại!",
  "userDeptRole.canNotAssignAdminRole":
    "Bạn không có quyền cập nhật quyền đang chọn!",
  "user.invalidAdminRight": "Bạn không có quyền cập nhật thông tin user!",

  "outgoingDoc.banHanh.invalidBookNumberAndDocDate":
    "Ngày văn bản không hợp lệ. Vui lòng kiểm tra lại",
  "outgoingDoc.banHanh.duplicateDocCode": "Số ký hiệu văn bản đã tồn tại",
  "outgoingDoc.banHanh.duplicateBookNumber": "Số sổ đã tồn tại",

  "vbIncomingDoc.canNotViewDoc":
    "Bạn không có quyền xem thông tin văn bản do thông tin đăng nhập không hợp lệ",
  "vbOutgoingDoc.canNotViewDoc":
    "Bạn không có quyền xem thông tin văn bản do thông tin đăng nhập không hợp lệ",

  "delegateInfo.fromDateInvalid": "Giá trị từ ngày không phù hợp",
  "delegateInfo.invalidDateRange": "Khoảng thời gian hiệu lực không phù hợp",
  "delegateInfo.existDelegateWithFromUser": "Đã tồn tại ủy quyền",
  "delegateInfo.canNotDelete": "Không thể xóa ủy quyền đã được kích hoạt",
  "delegateInfo.invalidAdminRight":
    "Người quản trị không có quyền thao tác trên thông tin người ủy quyền/được ủy quyền",
  "delegateInfo.fromUserStatusInvalid":
    "Trạng thái người ủy quyền không phù hợp",
  "delegateInfo.fromUserDeptRoleStatusInvalid":
    "Trạng thái người ủy quyền không phù hợp",
  "delegateInfo.toUserStatusInvalid":
    "Trạng thái người được ủy quyền không phù hợp",
  "delegateInfo.toUserDeptRoleStatusInvalid":
    "Trạng thái người được ủy quyền không phù hợp",
  "delegateInfo.fromUserRoleCodeInvalid": "Người ủy quyền phải là lãnh đạo",
  "delegateInfo.delegateRelationInvalid":
    "Người được ủy quyền phải ở trong đơn vị người ủy quyền",
  "delegateInfo.toUserRoleCodeInvalid":
    "Người được ủy quyền phải là lãnh đạo trong TH ủy quyền cho nhân sự của đơn vị trực thuộc",
  "delegateInfo.updateDataInvalid": "Dữ liệu cập nhật không phù hợp",
  "delegateInfo.fromUserMustDiffWithToUser":
    "Thông tin người được ủy quyền trùng với người ủy quyền",

  "delegateInfo.type.label.docProcess": "Xử lý văn bản",
  "delegateInfo.type.label.task": "Giao việc",

  "signToken.publisherInfo": "Ký bởi: {0} \nNgày ký: {1}",
  "signToken.kyCoDau": "\nKý bởi: {0} \n\nNgày ký: {1}",
  "signToken.docCode": "{0}",
  "signToken.bookNumber": "{0}",
  "signToken.defaultText": "{0}",
  "signToken.chiDao": "{0}",
  "signToken.docDate": "ngày {0} tháng {1} năm {2}",
  "signToken.phuLuc": "Số {0} {1}",
  "signToken.saoY": "SAO Y; {0}; {1}",
  "signToken.saoLuc": "SAO LỤC; {0}; {1}",
  "signToken.trichSao": "TRÍCH SAO; {0}; {1}",
  "signToken.docDate.title": "Ngày văn bản",
  "signToken.chiDao.title": "Ý kiến chỉ đạo của ông/bà {0}",
  "signToken.soDen.title": "Số đến",
  "signToken.incomingDate.title": "Ngày đến",
  "signToken.docCode.title": "Ký hiệu văn bản",
  "signToken.phuLuc.title": "Thông tin phụ lục",
  "signToken.phuLuc.vbdinhkem.error": "Bạn chưa thêm phụ lục cho văn bản đính kèm",
  "signToken.publisherInfo.title": "Thông tin cơ quan",
  "signToken.kyCoDau.title": "Thông tin cơ quan có con dấu",
  "signToken.saoY.title": "Sao y",
  "signToken.saoLuc.title": "Sao lục",
  "signToken.trichSao.title": "Trích sao",
  "signToken.error.missingDocDate": "Bạn chưa thêm ngày văn bản",
  "signToken.error.missingDocCode": "Bạn chưa thêm số ký hiệu văn bản",
  "signToken.error.missingSignature": "Bạn chưa thêm chữ ký",
  "signToken.error.warningForLanhDaoNotes":
    "Ý kiến của lãnh đạo nên chưa được thêm vào văn bản này",
  "signToken.error.missingStamp":
    "Con dấu chưa được thêm. Bạn có muốn tiếp tục ?",
  "signToken.error.missingPublisherInfo": "Bạn chưa thêm Thông tin cơ quan",

  "hcCfgCard.driverNotFound": "Không tìm thấy thông tin lái xe",
  "hcCfgCard.userCanNotAssignDriver":
    "Người dùng không có quyền chọn thông tin lái xe",
  "hcCfgCard.userCanNotUpdateCar":
    "Người dùng không có quyền cập nhật thông tin lái xe",

  "vbIncomingProcess.chuyenXuLi.receiverMissMatch":
    "Bạn không có quyền chuyển văn bản này",
  "vbIncomingProcess.chuyenXuLi.processStatusMissMatch":
    "Trạng thái văn bản không hợp lệ",
  "vbIncomingProcess.chuyenXuLi.posTypeMissMatch":
    "Theo quy định, bạn không có quyền chuyển xử lý văn bản này",
  "vbIncomingProcess.chuyenXuLi.alreadyForwardedHandler":
    "Trong danh sách, đã có người được chuyển xử lý văn bản này trước đó",

  "vbAttachment.objectType.vbDiCommon": "Xem nội dung văn bản",
  "vbAttachment.delete.confirm": "Bạn có muốn xóa file  {0}",
  "vbAttachment.delete.success": "Xóa file thành công",
  "vbAttachment.objectType.vbDi": "Xem nội dung văn bản",
  "vbAttachment.objectType.vbDiSingWithToken": "Văn bản ban hành có chữ ký số",
  "vbAttachment.objectType.vbDiSingWithTokenWithoutStamp":
    "Văn bản không có con dấu",
  "vbAttachment.objectType.vbDiReference": "Văn bản ban hành thể hiện",

  "vbIncomingDoc.cxl.vbFlowNotAllow": "Cấu hình không cho phép chuyển tiếp văn",
  "vbIncomingDoc.cxl.delegateNotAllow":
    "Không thể chuyển xử lý văn bản uỷ quyền",
  "vbIncomingDoc.cxl.statusMissMatch": "Trạng thái văn bản không hợp",
  "vbOutgoingDoc.delete.error.choBanHanh":
    "Văn bản không phải là văn bản chờ ban hành",
  "vbOutgoingDoc.delete.error.vbKyNgoai":
    "Văn bản không phải là văn bản ký ngoài",
  "vbOutgoingDoc.delete.error.donViVanThu":
    "Người dùng phải là văn thư của đơn vị ban hành văn bản",
  "vbOutgoingDoc.delete.error.vanThu":
    "Người dùng phải là văn thư của đơn vị ban hành văn bản",
  "vbOutgoingDoc.filterByStatus.daXoa": "Đã xóa",
  "groups.create.missUserDept": "Chưa chọn người hoặc đơn vị",
  "groups.create.duplicateName": "Tên nhóm đã tồn tại",

  "jobIndexPage.pageTitle.receiver": "Công việc được giao",
  "jobIndexPage.pageTitle.assigner": "Công việc tôi giao",
  "jobIndexPage.pageTitle.deptAssigner": "Công việc đơn vị",
  "jobIndexPage.pageTitle.coordinator": "Công việc liên quan",
  "jobIndexPage.pageTitle.all": "Tất cả công việc",

  "vbIncomingDoc.delete.invalidKyNgoai":
    "Văn bản không được xóa do không phù hợp",
  "vbIncomingDoc.delete.deptIdNotMatch":
    "Chỉ văn thư đơn vị mới có quyền xóa văn bản",
  "vbIncomingDoc.delete.statusInvalid":
    "Văn bản không thể xóa do đã có người chuyển xử lý",
  "vbOutgoingDoc.create.PhieuYKienNotFound": "Chưa bổ sung đầy đủ phiếu ý kiến",
  "vbOutgoingDoc.create.FileYKienNotFound": "Chưa bổ sung đầy đủ phiếu ý kiến",
  "vbOutgoingDoc.create.warningForMissingFieuYKien":
    "Bạn Chưa bổ sung đầy đủ phiếu ý kiến. Bạn có chắc muốn tiếp tục",

  //region hành chính
  DUPLICATE_TIME: "Đã có lịch làm việc của lãnh đạo {?} trong thời gian này",
  NO_HCCASECALENDARS:
    "Không có yêu cầu lịch tuần nào trong khoảng thời gian này",
  EXIST_APPROVER: "Lãnh đạo trả ra đã tồn tại trong danh sách trình",
  //endregion

  "canhBaoQuaHan.toiHan.label": "sắp tới hạn (còn {0} ngày)",
  "canhBaoQuaHan.quaHan.label": "quá hạn {0} ngày",

  /* Thu vien dung chung start */
  "sharelibrary.validate.titleIsEmpty":
    "Tiêu đề văn bản mẫu không được để trống",
  "sharelibrary.validate.codeIsEmpty": "Mã văn bản mẫu không được để trống",
  "sharelibrary.validate.attachmentIsEmpty":
    "File đính kèm không được để trống",
  "sharelibrary.validate.attachmentIsWrong": "File đính kèm không đúng",
  "sharelibrary.validate.codeIsDuplicate": "Mã văn bản mẫu đã tồn tại",
  "sharelibrary.validate.attachmentNotFound":
    "File đính kèm không được để trống",
  "sharelibrary.error.attachmentSaveError": "Lỗi xảy ra khi lưu file đính kèm",
  "sharelibrary.create.invalidForm": "Kiểm tra lại form nhập liệu",
  /* Thu vien dung chung send */

  "otp.isdnRequired":
    "Không thể gửi mã OTP do tài khoản không có thông tin số điện thoại. Mời liên hệ quản trị để thực hiện bổ sung",
  "validateOtpService.otpMissMatch": "Mã OTP không hợp lệ",

  "authenticate.authenHeaderRequired": "Thông tin đăng nhập không hợp lệ",
  "authenticate.authenHeaderInvalid": "Thông tin đăng nhập không hợp lệ",
  "authenticate.userIsDeactivated": "Tài khoản đã dưng hoạt động",
  "authenticate.userAndUserDeptRoleIdNotMatch":
    "Thông tin đăng nhập không hợp lệ",
  "authenticate.jwtExpired":
    "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
  "authenticate.otherExpired":
    "Phiên đăng nhập bị hủy ,hết hạn hoặc có người đăng nhập vào tài khoản của bạn. Vui lòng đăng nhập lại.",
  "authenticate.otpTokenRequired": "Thông tin đăng nhập không hợp lệ",
  "authenticate.otpTokenMissMatch": "Thông tin đăng nhập không hợp lệ",
  "authenticate.otpTokenExpired":
    "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
  "authenticate.userNotExists":
    "Tài khoản không tồn tại trong hệ thống. Mời liên hệ quản trị.",
  "authenticate.userDeptRoleNotExists":
    "Tài khoảng chưa được phân quyền. Mời liên hệ quản trị.",
  "authenticate.userNotPermissionEnterApp":"Tài khoản của bạn chưa được phân quyền vào EOffice. Mời liên hệ quản trị.",

  "task.status.chopheduyetdk.label": "Chờ phê duyệt",
  "task.status.dangthuchien.label": "Chưa hoàn thành",
  "task.status.huypheduyetdangky.label": "",
  "task.status.hoanthanh.label": "Hoàn thành",
  "task.status.tamdung.label": "Tạm dừng",
  "task.status.ketthuc.label": "Kết thúc",
  "task.status.huy.label": "Hủy",

  "users.changePassword.currentPasswordNotMatch": "Mật khẩu không đúng",

  "steeringType.label.khongphaichidao": "Không phải chỉ đạo",
  "steeringType.label.chidao": "Chỉ đạo",
  "steeringType.label.baocaochidao": "Báo cáo chỉ đạo",

  "vpcpApi.error":
    "Có lỗi khi thực hiện ban hành văn bản lên trục liên thông văn bản. Mời liên hệ quản trị để được hỗ trợ",
  "mobimeetingApi.error":
    "Có lỗi khi thực hiện giao tiếp với hệ thống MobiMeeting. Mời liên hệ quản trị để được hỗ trợ",

  "banhanh.confirmUpdateForBanHanhTltvbMessage":
    "Văn bản cần bổ sung thông tin để ban hành văn bản lên trục liên thông văn bản.",
  "vbOutgoingDoc.updateTltvbData.publisherIdNotMatch":
    "Chỉ có văn thư đơn vị ban hành mới có quyền thao tác",
  "vbOutgoingDoc.updateTltvbData.publisherIsNotTCT":
    "Chỉ văn bản ban hành từ TCT mới được phép gửi lên trục liên thông",
  "vbOutgoingDoc.updateTltvbData.statusNotMatch":
    "Trạng thái văn bản không hợp lệ",
  "vbOutgoingDoc.updateTltvbData.creatorNotMatch":
    "Chỉ có văn thư đơn vị ban hành mới có quyền thao tác",

  "hcLichTuan.vbAttachmentIsInvalid": "Thông tin file đính kèm không hợp lệ",
  "hcLichTuan.deleteAttachment.confirmMessage":
    "Bạn có muốn xóa yêu file đính kèm '{0}' ?",
  "hcLichTuan.canNotDownloadAttachment": "Bạn không có quyền tải tệp",
  "hcLichTuan.canNotDownloadAttachment2":
    "Bạn không có quyền tải tệp do thông tin đăng nhập không hợp lệ",

  "hcCaseCalendar.hcFlowDeptId.required": "Cấp quy trình chưa được chọn",
  "hcCaseCalendar.leaders.required":
    "Danh sách lãnh đạo chưa được chọn. Vui lòng chọn lãnh đạo",
  "hcCaseCalendar.meetingType.online.label": "Tạo phòng họp Mobimeeting mới",
  "hcCaseCalendar.meetingPlace.online.label": "Họp Mobimeeting",
  "hcCaseCalendar.meetingType.offline.label": "Họp thường",
  "hcCaseCalendar.meetingType.online.mobimeetingCoDinh":
    "Phòng họp Mobimeeting cố định",
  "hcCaseCalendar.meetingType.online.other": "Khác",
  "hcCaseCalendar.joinRoomForbidden":
    "Bạn không có quyền tham dự cuộc họp trực tuyến này",
  "hcCaseCalendar.duplidatedRoom.confirm":
    "Phòng họp đã được sử dụng cho cuộc họp [{0}]. Bạn có chắc muốn tiếp tục.",
  "hcCaseCalendar.duplidatedRoom.error":
    "Phòng họp đã được sử dụng cho cuộc họp [{0}].",

  "tienDoHoanThanhCv.type.truocHan": "Trước hạn",
  "tienDoHoanThanhCv.type.dungHan": "Đúng hạn",
  "tienDoHoanThanhCv.type.quaHan": "Quá hạn",

  "rankingReason.type.congDiem": "Cộng điểm",
  "rankingReason.type.truDiem": "Trừ điểm",
  "rankingReason.scoreType.chuyenMon": "Chuyên môn",
  "rankingReason.scoreType.nguyenTac": "Nguyên tắc",
  "rankingReason.changeStatus.confirm":
    "Bạn có chắc muốn cập nhật trạng thái lý do",
  "rankingReason.delete.confirm": "Bạn có chắc muốn xóa lý do",
  "rankingScore.delete.confirm": "Bạn có chắc muốn xóa đánh giá",
  "rankingScore.delete.success": "Xóa đánh giá thành công",
  "rankingScore.update.success": "Cập nhật đánh giá thành công",
  "rankingScore.insert.success": "Thêm mới đánh giá thành công",
  "rankingScore.invalidUserDeptRoleId":
    "Bạn không có quyền đánh giá nhân viên được chọn.",
  "rankingReason.invalidAuthorization":
    "Bạn không có quyền thực hiện chức năng này.",
  "rankingScore.invalidDeptId":
    "Bạn không có quyền đánh giá nhân viên được chọn.",
  "shortLink.notFound": "Đường dẫn không khả dụng hoặc đã hết hạn",

  "meetingRoom.type.normal": "Phòng họp thường",
  "meetingRoom.type.mobimeetingCoDinh": "Phòng họp mobimeeting cố định",
  "meetingRoom.delete.confirm": "Bạn có chắc chắn muốn xóa phòng họp được chọn",
  "hcCfgMeetingRoom.duplicatedRoomName": "Tên phòng đã tồn tại",
  "hcCfgMeetingRoom.duplicatedRoomCode": "Mã phòng đã tồn tại",

  "bookDoc.type.outOfQuantity": "Đã hết",
  "bookDoc.banhanhConfirm":
    "Số bạn vừa chọn thuộc dải số [{0}-{1}] đã book ngày [{2}] cho đơn vị [{3}]. Bạn có muốn tiếp tục lấy số từ dải số đã giữ ?",
  "bookDoc.banhanhConfirm.noDeptName":
    "Số bạn vừa chọn thuộc dải số [{0}-{1}] đã book ngày [{2}]. Bạn có muốn tiếp tục lấy số từ dải số đã giữ ?",
  "hcCaseCalendar.meetingPlace.mobimeetingCoDinh.label": "Họp Mobimeeting, {0}",

  // message chung cho tất cả quy trình: kết luận chỉ đạo, công việc trọng tâm, quy chế quy định
  "hcQuyTrinh.insertSuccess": "Tạo yêu cầu thành công",
  "hcQuyTrinh.updateSuccess": "Cập nhật yêu cầu thành công",
  "hcQuyTrinh.baoCaoSuccess": "Báo cáo chỉ đạo thành công",
  "hcQuyTrinh.pheDuyetSuccess": "Phê duyệt chỉ đạo thành công",
  "hcQuyTrinh.yeuCauBoSungSuccess": "Yêu cầu bổ sung báo cáo chỉ đạo thành công",
  "hcQuyTrinh.giaHanSuccess": "Xin gia hạn thành công",
  "hcQuyTrinh.giaHanQuaSoLan":
    "Đơn vị đã gia hạn quá số lần quy định (2 lần)",
  "hcQuyTrinh.duplicateRoleDonViThuHien":
    "Thông tin đơn vị chủ trì/phối hợp không đúng. Một đơn chỉ chỉ có thể là chủ trì hoặc phối hợp",
  "hcQuyTrinh.donViChuTriRequired":
    "Thông tin đơn vị chủ trì bắt buộc nhập",
  "hcQuyTrinh.duplicateChiDaoActor":
    "Thông tin lãnh đạo chỉ đạo/phụ trách không đúng. Một người chỉ có thể có vai trò chỉ đạo hoặc phụ trách",
  "hcQuyTrinh.invalidCommandsDateAndDeadline":
    "Thời hạn hoàn thành không được nhỏ hơn ngày chỉ đạo",
  "hcQuyTrinh.invalidDeadlineAndNow":
    "Thời hạn hoàn thành không được nhỏ hơn ngày hiện tại",
  "hcQuyTrinh.invalidDeadlineAndNextDeadline":
    "Thời gian được gia hạn lần 1 phải lớn hơn thời hạn hoàn thành",
  "hcQuyTrinh.invalidNextDeadlineAndNow":
    "Thời gian được gia hạn lần 1 không được nhỏ hơn ngày hiện tại",
  "hcQuyTrinh.invalidNextDeadlineAndNextDeadline2":
    "Thời gian được gia hạn lần 2 phải lớn hơn thời gian được gia hạn lần 1",
  "hcQuyTrinh.invalidNextDeadline2AndNow":
    "Thời gian được gia hạn lần 2 không được nhỏ hơn ngày hiện tại",
  "hcQuyTrinh.dangKyDeadlineSuccess": "Đăng ký thời hạn hoàn thành thành công",
  "hcQuyTrinh.huyYeuCauSuccess": "Hủy kết luận chỉ đạo thành công",
  "hcQuyTrinh.invalidAction":
    "Trạng thái dữ liệu không hợp lệ hoặc bạn không có quyền thực hiện thao tác này",
  "hcQuyTrinh.baoTrungSuccess": "Đánh dấu trùng chỉ đạo thành công",
  "hcQuyTrinh.choYkienSuccess": "Cho ý kiến chỉ đạo thành công",
  "hcQuyTrinh.toiHan.label": "sắp tới hạn (còn {0} ngày)",
  // END message chung cho tất cả quy trình: kết luận chỉ đạo, công việc trọng tâm, quy chế quy định

  "hcCommand.insertSuccess": "Tạo yêu cầu thành công",
  "hcCommand.updateSuccess": "Cập nhật yêu cầu thành công",
  "hcCommand.baoCaoSuccess": "Báo cáo chỉ đạo thành công",
  "hcCommand.pheDuyetSuccess": "Phê duyệt chỉ đạo thành công",
  "hcCommand.yeuCauBoSungSuccess": "Yêu cầu bổ sung báo cáo chỉ đạo thành công",
  "hcCommand.giaHanSuccess": "Xin gia hạn thành công",
  "hcCaseCommands.giaHanQuaSoLan":
    "Đơn vị đã gia hạn quá số lần quy định (2 lần)",
  "hcCaseCommands.duplicateRoleDonViThuHien":
    "Thông tin đơn vị chủ trì/phối hợp không đúng. Một đơn chỉ chỉ có thể là chủ trì hoặc phối hợp",
  "hcCaseCommands.donViChuTriRequired":
    "Thông tin đơn vị chủ trì bắt buộc nhập",
  "hcCaseCommands.duplicateChiDaoActor":
    "Thông tin lãnh đạo chỉ đạo/phụ trách không đúng. Một người chỉ có thể có vai trò chỉ đạo hoặc phụ trách",
  "hcCommands.invalidCommandsDateAndDeadline":
    "Thời hạn hoàn thành không được nhỏ hơn ngày chỉ đạo",
  "hcCommands.invalidDeadlineAndNow":
    "Thời hạn hoàn thành không được nhỏ hơn ngày hiện tại",
  "hcCommands.invalidDeadlineAndNextDeadline":
    "Thời gian được gia hạn lần 1 phải lớn hơn thời hạn hoàn thành",
  "hcCommands.invalidNextDeadlineAndNow":
    "Thời gian được gia hạn lần 1 không được nhỏ hơn ngày hiện tại",
  "hcCommands.invalidNextDeadlineAndNextDeadline2":
    "Thời gian được gia hạn lần 2 phải lớn hơn thời gian được gia hạn lần 1",
  "hcCommands.invalidNextDeadline2AndNow":
    "Thời gian được gia hạn lần 2 không được nhỏ hơn ngày hiện tại",
  "hcCommand.dangKyDeadlineSuccess": "Đăng ký thời hạn hoàn thành thành công",
  "common.formDataNotChange": "Dữ liệu không có sự thay đổi",
  "hcCommand.huyYeuCauSuccess": "Hủy kết luận chỉ đạo thành công",
  "hcCaseCommands.invalidAction":
    "Trạng thái dữ liệu không hợp lệ hoặc bạn không có quyền thực hiện thao tác này",
  "hcCommand.baoTrungSuccess": "Đánh dấu trùng chỉ đạo thành công",
  "hcCommand.choYkienSuccess": "Cho ý kiến chỉ đạo thành công",
  "hcCommand.toiHan.label": "sắp tới hạn (còn {0} ngày)",

  "hcLichTuan.canNotViewDetail":
    "Bạn không có quyền xem chi tiết theo dõi chỉ đạo do thông tin đăng nhập không hợp lệ",
  "absence.create.duplicate":"Đã tồn tại lịch báo vắng trong khoảng thời gian này",
  "common.update.timeNotMatch":
    "Thao tác có thể đã được thực hiện trước đó vui lòng reload lại để tiếp tục sử dụng",

  "hcDriver.insertSuccess": "Thêm thông tin tài xế thành công",
  "hcDriver.changeStatusSuccess":
    "Thay đổi trạng thái thông tin tài xế thành công",
  "hcDriver.updateSuccess": "Thay đổi thông tin tài xế thành công",
  "hcDriver.deleteSuccess": "Xóa thông tin tài xế thành công",
  "hcCfgDriver.create.invalidForm": "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
  "hcCfgDriver.update.invalidForm": "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
  "hcCfgDriver.userCanNotUpdateCar":
    "Bạn không có quyền thực hiện chức năng này",

  "hcCar.insertSuccess": "Thêm thông tin xe thành công",
  "hcCar.changeStatusSuccess": "Thay đổi trạng thái thông tin xe thành công",
  "hcCar.updateSuccess": "Thay đổi thông tin xe thành công",
  "hcCar.deleteSuccess": "Xóa thông tin xe thành công",
  "hcCfgCar.invalidForm": "Có lỗi nhập liệu. Vui lòng kiểm tra lại",
  "hcCfgCar.userCanNotUpdateCar": "Bạn không có quyền thực hiện chức năng này",

  "hcDieuXe.insertSuccess": "Gửi yêu cầu thành công",
  "hcDieuXe.invalidTimeRange": "Thời gian về phải sau thời gian đi",
  "hcDieuXe.approveSuccess": "Phê duyệt yêu cầu thành công",
  "hcDieuXe.updateSuccess": "Cập nhật yêu cầu thành công",
  "hcDieuXe.rejectSuccess": "Từ chối yêu cầu thành công",
  "hcDieuXe.cancelSuccess": "Hủy yêu cầu thành công",
  "hcDieuXe.duplicatedCar": "Thông tin xe {0} bị lặp",
  "hcDieuXe.duplicatedDriver": "Thông tài xế {0} bị lặp",
  "hcDieuXe.canNotViewDetail":
    "Bạn không có quyền xem chi tiết yêu cầu điều xe do thông tin đăng nhập không hợp lệ",

  CANNOT_APPROVE:
    "Trạng thái yêu cầu không hợp lệ hoặc bạn không có quyền thực hiện chức năng này",
  CANNOT_START:
    "Trạng thái yêu cầu không hợp lệ hoặc bạn không có quyền thực hiện chức năng này",
  BUSY_ROOM: "Phòng hợp đã bận trong khoảng thời gian này!",

  "hcMayBay.files.required": "File tờ trình bắt buộc nhập",
  "hcMayBay.ticketFiles.required": "Vé máy bay bắt buộc nhập",
  "hcMayBay.users.required": "Thông tin cán bộ bắt buộc nhập",
  "hcMayBay.routes.required": "Thông tin chặng bay bắt buộc nhập",
  "hcMayBay.userRoutes.required":
    "Thông tin thời gian bay thực tế/số vé bắt buộc nhập",
  "hcFlight.insertSuccess": "Gửi yêu cầu thành công",
  "hcFlight.approveSuccess": "Phê duyệt yêu cầu thành công",
  "hcFlight.updateSuccess": "Cập nhật yêu cầu thành công",
  "hcFlight.cancelSuccess": "Hủy yêu cầu thành công",
  "hcFlight.rejectSuccess": "Từ chối yêu cầu thành công",
  "hcFlight.airport.duplicated": "Điểm đến không được trùng với điểm đi",

  "category.insertSuccess": "Thêm mới danh mục thành công",
  "category.updateSuccess": "Cập nhật danh mục thành công",
  "category.deleteSuccess": "Xóa danh mục thành công",
  "category.changeStatue.confirm":
    "Bạn có chắc muốn cập nhật trạng thái danh mục",
  "category.delete.confirm": "Bạn có chắc muốn xóa trạng thái danh mục",
  "hcCaseFlight.canNotViewDetail":
    "Bạn không có quyền xem chi tiết yêu cầu đặt vé máy bay do thông tin đăng nhập không hợp lệ",

  "hcHotel.invalidTimeRange":
    "Thời gian checkout phải lớn hơn thời gian checkin",
  "hcCaseHotel.insertSuccess": "Gửi yêu cầu thành công",
  "hcHotel.hotels.required": "Thông tin lưu trú bắt buộc nhập",
  "hcHotel.users.required": "Thông tin cán bộ bắt buộc nhập",
  "hcHotel.cancelSuccess": "Hủy yêu cầu thành công",
  "hcHotel.cancel.confirm": "Bạn có chắc muốn hủy yêu cầu này",
  "hcHotel.approveSuccess": "Phê duyệt yêu cầu thành công",
  "hcHotel.ticketFiles.required": "Giấy tờ khách sạn bắt buộc nhập",
  "hcHotel.location.priceRequired": "Đơn giá bắt buộc nhập với phòng đã đặt",
  "hcHotel.reject.confirm": "Bạn chắc chắn muốn từ chối yêu cầu này ?",
  "hcHotel.rejectSuccess": "Từ chối yêu cầu thành công",
  "hcHotel.updateSuccess": "Cập nhật yêu cầu thành công",
  "hcCaseHotel.canNotViewDetail":
    "Bạn không có quyền xem chi tiết yêu cầu đặt phòng khách sạn do thông tin đăng nhập không hợp lệ",
  "hcCaseSCN.canNotViewDetail":
    "Bạn không có quyền xem chi tiết yêu cầu sửa chữa nhỏ do thông tin đăng nhập không hợp lệ",
  "hcHotel.users.removeConfirm": "Bạn có chắc muốn xóa thông tin cán bộ",
  "hcHotel.places.deleteConfirm": "Bạn có chắc muốn xóa thông tin lưu trú",
  "hcHotel.file.deleteConfirm": "Bạn có chắc muốn xóa tệp tin",
  "hcHotel.places.invalidCount": "Số lượng phòng bắt buộc nhập",
  "vbDen.toTrinhQuaHan.canNotViewDetail":
    "Bạn không có quyền truy cập tính năng này do thông tin đăng nhập không hợp lệ",

  "hcPhongHop.invalidTimeRange":
    "Thời gian bắt đầu không được lớn hơn thời gian kết thúc",
  "hcPhongHop.insertSuccess": "Gửi yêu cầu thành công",
  "hcPhongHop.approveSuccess": "Phê duyệt yêu cầu thành công",
  "hcPhongHop.declineSuccess": "Từ chối yêu cầu thành công",
  "hcPhongHop.decline.confirm": "Bạn có muốn từ chối yêu cầu đăng ký này?",
  "hcPhongHop.cancelSuccess": "Hủy yêu cầu thành công",
  "hcPhongHop.cancel.confirm": "Bạn có muốn hủy yêu cầu đăng ký này?",
  "hcPhongHop.updateSuccess": "Cập nhật yêu cầu thành công",
  "hcPhongHop.update.confirm": "Bạn có muốn cập nhật phòng họp?",
  "hcPhongHop.canNotViewDetail":
    "Bạn không có quyền xem chi tiết yêu cầu đặt phòng khách sạn do thông tin đăng nhập không hợp lệ",
  "hcSCN.updateSuccess": "Cập nhật sửa chữa nhỏ thành công",
  "hcSCN.rejectSuccess": "Từ chối sửa chữa nhỏ thành công",
  "hcSCN.cancelSuccess": "Hủy sửa chữa nhỏ thành công",
  "hcSCN.insertSuccess": "Thêm mới sửa chữa nhỏ thành công",
  "hcSCN.approveSuccess": "Phê duyệt sửa chữa nhỏ thành công",
  "hcSCN.approve.confirm":
    "Bạn có chắc muốn phê duyệt yêu cầu sửa chữa nhỏ này?",
  "hcSCN.reject.confirm": "Bạn có chắc muốn từ chối yêu cầu sửa chữa nhỏ này? ",
  "hcSCN.cancel.confirm": "Bạn có chắc muốn hủy yêu cầu sửa chữa nhỏ này? ",
  "vbOutgoingDoc.suaSai.invalidDocStatus":
    "Văn bản phải ở trạng thái đã ban hành",
  "vbOutgoingDoc.suaSai.invalidAuthorization":
    "Bạn không có quyền thực hiện thao tác này",
  "vbOutgoingDoc.suaSai.vbBanHanhTrucLienThong":
    "Không thể cập nhật văn bản đã ban hành trên trục liên thông",
  "vbOutgoingDoc.updateSuccess": "Cập nhật văn bản thành công",
  "hcCaseCalendar.phongHopFlowNotDeclared":
    "Quy trình phòng họp chưa được khai báo. Bạn hãy liên hệ quản trị để được hỗ trợ",
  "authenticate.BlacklistJwtException": "Phiên làm việc hết hạn!",
  "tkTaskDocRelation.create.userCanNotAccessDoc": "tkTaskDocRelation.create.userCanNotAccessDoc",
  "tkTaskDocRelation.create.userCanNotAccessTask": "tkTaskDocRelation.create.userCanNotAccessTask",
  "vbDocInBook.create.setNewSubBookNumber": "Số phụ đã tồn tại trong sổ, chuyển sang số phụ {0}.",
  "vbDocUer.setIsStarError": "Bạn không có quyền đánh dấu sao văn bản",
  "attachment.convertSuccess": "Tải file mẫu thành công",
  "attachment.convertFailed": "Tải file mẫu thất bại"
};

export default function(options) {
  let params = options.params;
  let errorMessage =
    messageMapping[options.errorCode] || messageMapping["unknownError"];

  if (options.errorCode === "DUPLICATE_TIME") {
    let paramJoin = "";
    h.each(params, (param, index) => {
      if (index > 0) {
        param = ", " + param;
      }
      paramJoin = paramJoin + param;
    });
    errorMessage = errorMessage.split(`{?}`).join(paramJoin);
   } else if (options.errorCode === "signCA.error"){
    let paramJoin = "";
    h.each(params, (param, index) => {
      if(messageMapping[param]){
        paramJoin = paramJoin + messageMapping[param];
      }
    });
    errorMessage = paramJoin || messageMapping[options.errorCode];
  }
  else {
    h.each(
      params,
      (param, index) =>
        (errorMessage = errorMessage.split(`{${index}}`).join(param))
    );
  }

  return errorMessage;
}



// WEBPACK FOOTER //
// ./src/filters/errorMessageFilter.js